import { filterLocationForPosting } from "app/components/helpers/filterLocationForPosting";
import PostModel, { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";

interface Props {
  onPost?: (post: PostModel) => void;
}

export const useFeedPostingForm = ({ onPost }: Props) => {
  const { user, canSchedulePosts, canAddMedia, canPostMedia, canUploadMedia, postActions } =
    usePostingFormBase();

  const { selectedDestinations } = useSelector(
    (state: RootState) => state.destinations,
    shallowEqual,
  );

  const onSubmit = (data: PostingModel): void => {
    if (selectedDestinations) {
      const filteredDestinations =
        filterLocationForPosting(selectedDestinations);

      postActions
        .createPost({ ...data, ...filteredDestinations })
        .then((res): void => {
          if (onPost) {
            onPost({ ...res, userAvatar: user.avatar });
          }
        });
    }
  };

  return {
    canSchedulePosts,
    canAddMedia,
    canPostMedia,
    canUploadMedia,
    onSubmit,
  };
};
